import React, { useState } from "react";
import AboutImg from "../assets/about/Aboutus.jpg";
import SchoolImg from "../assets/about/school.jpg";
import PrincipalImg from "../assets/about/principal.jpg";
import StaffImg from "../assets/about/staffinfo.jpg";
import InfraImg from "../assets/about/infrastructure.jpg";

const About = () => {

  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <style>{`
        .page {
          padding: 0px;
          font-family: Arial, sans-serif;
          background-color: #f9fafb;
          color: #333;
        }

        .container {
          max-width: 1000px;
          margin: auto;
        }

        .about-banner img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          display:block;
        }

       .container h2 {
       text-align: center;
       margin: 40px 0;
       font-size: 32px;
       color: #1e3a8a;
       }

        .section {
          background: #ffffff;
          padding: 20px;
          margin-bottom: 20px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          display: flex;
          gap: 20px;
          align-items: center;
        }

        .section img {
          width: 250px;
          height: 150px;
          object-fit: cover;
          border-radius: 10px;
          cursor: pointer;
          transition: transform 0.3s;
        }

        .section img:hover {
          transform: scale(1.05);
        }

        .section-content {
          flex: 1;
        }

        .section h3 {
          margin-bottom: 10px;
          color: #1e3a8a;
        }

        .section p {
          line-height: 1.6;
          font-size: 15px;
        }

        /* 🔷 MODAL STYLE */
        .modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

        .modal img {
          max-width: 80%;
          max-height: 80%;
          border-radius: 10px;
          box-shadow: 0 0 20px rgba(255,255,255,0.3);
        }

        .close-btn {
          position: absolute;
          top: 20px;
          right: 30px;
          font-size: 30px;
          color: #fff;
          cursor: pointer;
          font-weight: bold;
        }

        @media (max-width: 768px) {
          .section {
            flex-direction: column;
            text-align: center;
          }

          .section img {
            width: 100%;
            height: auto;
          }

          .about-banner img {
            height: auto;
          }
        }
      `}</style>

      <div className="page">

        {/* 🔷 Banner */}
        <div className="about-banner">
          <img src={AboutImg} alt="About School Banner" />
        </div>

        <div className="container">

          <h2>About Our School</h2>

          {/*  School History */}
          <div className="section">
            <img src={SchoolImg} alt="School" onClick={() => setSelectedImg(SchoolImg)} />
            <div className="section-content">
              <h3>School History</h3>
              <p>Sharada Hill Modern School, located in Arakhapur, Ganjam, Odisha, was established in the academic year 2024–25.
                Our institution has a proud legacy of academic excellence and holistic development. Established with a vision
                to nurture young minds, the school has consistently evolved to meet modern educational standards while preserving its core values.</p>
            </div>
          </div>

          {/* Principal */}
          <div className="section">
            <img src={PrincipalImg} alt="Principal" onClick={() => setSelectedImg(PrincipalImg)} />
            <div className="section-content">
              <h3>Principal’s Message</h3>
              <p>"Education is not just about knowledge, but about shaping character and future leaders."
                We provide a supportive environment where students grow with confidence, creativity, and strong values."</p>
            </div>
          </div>

          {/*  Staff */}
          <div className="section">
            <img src={StaffImg} alt="Staff" onClick={() => setSelectedImg(StaffImg)} />
            <div className="section-content">
              <h3>Staff Information</h3>
              <p> Our experienced and dedicated faculty ensures quality education through innovative teaching methods.
                They guide students toward academic success and personal development.</p>
            </div>
          </div>

          {/* Infrastructure */}
          <div className="section">
            <img src={InfraImg} alt="Infrastructure" onClick={() => setSelectedImg(InfraImg)} />
            <div className="section-content">
              <h3>Infrastructure Details</h3>
              <p> Our campus features modern classrooms, laboratories, libraries, and sports facilities,
                creating a safe and inspiring environment for learning and growth.</p>
            </div>
          </div>

        </div>

        {/* IMAGE MODAL */}
        {selectedImg && (
          <div className="modal" onClick={() => setSelectedImg(null)}>
            <span className="close-btn" onClick={() => setSelectedImg(null)}>×</span>
            <img src={selectedImg} alt="Zoomed" />
          </div>
        )}

      </div>
    </>
  );
};

export default About;